import React from "react";
import type { FC } from "react";

import { useSubscriptionState } from "./SubscriptionProvider.state";
import { SubscriptionProviderContext } from "./SubscriptionProvider.context";
import { ISubscriptionProviderProps } from "./SubscriptionProvider.types";

const SubscriptionProviderContextProvider = SubscriptionProviderContext.Provider;

const SubscriptionProvider: FC<ISubscriptionProviderProps> = (props) => {
  const { children } = props;

  const state = useSubscriptionState(props);

  return <SubscriptionProviderContextProvider value={state}>{children}</SubscriptionProviderContextProvider>;
};

export { SubscriptionProvider };
